import { ModalModule } from './modules/modal/modal.module';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './partials/footer/footer.component';
import { SignInComponent } from './pages/common/sign-in/sign-in.component';
import { PortfolioComponent } from './pages/common/portfolio/portfolio.component';
import { MainNavigationComponent } from './partials/navigation/main-navigation/main-navigation.component';
import { UserNavigationComponent } from './partials/navigation/user-navigation/user-navigation.component';
import { SignUpComponent } from './pages/common/sign-up/sign-up.component';
import { EmailConfirmationComponent } from './pages/common/email-confirmation/email-confirmation.component';
import { CommonNavigationComponent } from './partials/navigation/common-navigation/common-navigation.component';
import { DeliveryAddressComponent } from './pages/common/delivery-address/delivery-address.component';
import { UserDeliveryAddressComponent } from './pages/user/delivery-address/delivery-address.component';
import { PaymentMethodComponent } from './pages/common/payment-method/payment-method.component';
import { UserPaymentMethodComponent } from './pages/user/payment-method/payment-method.component';
import { DashboardComponent } from './pages/user/dashboard/dashboard.component';
import { ProfileComponent } from './pages/user/profile/profile.component';
import { ForgotPasswordComponent } from './pages/common/forgot-password/forgot-password.component';
import { DeleteUserComponent } from './pages/common/delete-user/delete-user.component';
import { NewPasswordComponent } from './pages/common/new-password/new-password.component';
import { EditDetailsComponent } from './pages/user/edit-details/edit-details.component';
import { ChangeEmailComponent } from './pages/user/change-email/change-email.component';
import { ChangePasswordComponent } from './pages/user/change-password/change-password.component';
import { SubscriptionComponent } from './pages/user/subscription/subscription.component';
import { BillingHistoryComponent } from './pages/user/billing-history/billing-history.component';
import { ManagerDashboardComponent } from './pages/user/manager-dashboard/manager-dashboard.component';
import { ReplaceBreathingDeviceComponent } from './pages/user/replace-breathing-device/replace-breathing-device.component';
import { VideosComponent } from './pages/user/videos/videos.component';
import { intersectionObserverPreset, LazyLoadImageModule, scrollPreset } from 'ng-lazyload-image';
import { BreathExerciseComponent } from './pages/user/breath-exercise/breath-exercise.component';
import { QuizComponent } from './pages/user/quiz/quiz.component';
import { SummaryComponent } from './pages/user/summary/summary.component';
import { SeriesNavigationComponent } from './pages/user/series-navigation/series-navigation.component';
import { ActivateAccountComponent } from './pages/common/activate-account/activate-account.component';
import { MarketingCollateralComponent } from './pages/user/marketing-collateral/marketing-collateral.component';
import { SeriesTwoComponent } from './pages/user/marketing-collateral/series-two/series-two.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PlyrModule } from 'ngx-plyr';
import { SortablejsModule } from 'ngx-sortablejs';
import { PortfolioNavigationComponent } from './partials/navigation/portfolio-navigation/portfolio-navigation.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { environment } from "../environments/environment";
import { SeriesThreeComponent } from './pages/user/marketing-collateral/series-three/series-three.component';
import { SeriesFourComponent } from './pages/user/marketing-collateral/series-four/series-four.component';
import { SeriesOneComponent } from './pages/user/marketing-collateral/series-one/series-one.component';
import { ListComponent as PodListComponent } from './pages/user/resources/pods/list/list.component';
import { ViewComponent as PodViewComponent } from './pages/user/resources/pods/view/view.component';
import { ListComponent as ScienceListComponent } from './pages/user/resources/science/list/list.component';
import { ViewComponent as ScienceViewComponent } from './pages/user/resources/science/view/view.component';
import { ListComponent as CommunityListComponent } from './pages/user/resources/community/list/list.component';
import { ViewComponent as CommunityViewComponent } from './pages/user/resources/community/view/view.component';
import { ListComponent as InsightListComponent } from './pages/user/resources/insights/list/list.component';
import { ViewComponent as InsightViewComponent } from './pages/user/resources/insights/view/view.component';
import { ListComponent as TipsListComponent } from './pages/user/tips/list/list.component';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    SignInComponent,
    PortfolioComponent,
    MainNavigationComponent,
    SignUpComponent,
    EmailConfirmationComponent,
    CommonNavigationComponent,
    DeliveryAddressComponent,
    PaymentMethodComponent,
    DashboardComponent,
    UserNavigationComponent,
    ProfileComponent,
    ForgotPasswordComponent,
    DeleteUserComponent,
    NewPasswordComponent,
    EditDetailsComponent,
    ChangeEmailComponent,
    ChangePasswordComponent,
    SubscriptionComponent,
    BillingHistoryComponent,
    ManagerDashboardComponent,
    ReplaceBreathingDeviceComponent,
    UserPaymentMethodComponent,
    UserDeliveryAddressComponent,
    VideosComponent,
    BreathExerciseComponent,
    QuizComponent,
    SummaryComponent,
    SeriesNavigationComponent,
    ActivateAccountComponent,
    PortfolioNavigationComponent,
    MarketingCollateralComponent,
    SeriesTwoComponent,
    SeriesThreeComponent,
    SeriesFourComponent,
    SeriesOneComponent,
    PodListComponent,
    PodViewComponent,
    ScienceListComponent,
    ScienceViewComponent,
    CommunityListComponent,
    CommunityViewComponent,
    InsightListComponent,
    InsightViewComponent,
    TipsListComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    LazyLoadImageModule.forRoot(intersectionObserverPreset),
    NgxPaginationModule,
    NgbModule,
    PlyrModule,
    ModalModule,
    SortablejsModule.forRoot({ animation: 150 }),
    //NgImageSliderModule,
    NgxUsefulSwiperModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: 'googleTagManagerId', useValue: environment.gtmId}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
